import { put, call } from 'redux-saga/effects';
import { dynamicFieldsList, dynamicFieldsUpdate, dynamicFieldsDataSave, dynamicFieldsMasterList } from '../../services/settings/dynamicfieldsService';

import * as types from '../../actions';

export function* dynamicFieldsListSaga(payload) { 
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(dynamicFieldsList, payload);
      yield put({ type: types.DYNAMIC_FIELDS_LIST_SUCCESS, response })
      
    } catch(error) {
      yield put({ type: types.DYNAMIC_FIELDS_LIST_ERROR, error });
    }finally{
      yield put({ type: types.HIDE_LOADER})
  }
} 

export function* dynamicFieldsMasterListSaga(payload) { 
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(dynamicFieldsMasterList, payload);
    yield put({ type: types.DYNAMIC_FIELDS_MASTER_LIST_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: types.DYNAMIC_FIELDS_MASTER_LIST_ERROR, error });
  }finally{
    yield put({ type: types.HIDE_LOADER})
}
}

export function* dynamicFieldsdUpdateSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(dynamicFieldsUpdate, payload); 
    yield put({ type: types.DYNAMIC_FIELDS_UPDATE_SUCCESS, response })
          
  } catch(error) { 
    yield put({ type: types.DYNAMIC_FIELDS_UPDATE_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* dynamicFieldsDataSaveSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(dynamicFieldsDataSave, payload);  
    yield put({ type: types.DYNAMIC_FIELDS_DATA_SAVE_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.DYNAMIC_FIELDS_DATA_SAVE_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}



